/* astra-home.js — shared interactivity for the AstraHelvetia homepage.
   Multi-instance safe: single init guard, document-wide queries, per-element
   bind flags, and theme-editor (shopify:section:load) re-binding. */
(function () {
  if (window.__astraHomeInit) return;
  window.__astraHomeInit = 1;

  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function reveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.ahh [data-reveal]');
    if (DESIGN || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var d = parseInt(el.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { el.classList.add('is-in'); }, d);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
  }

  function bindFaq(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.ahh-faq-item').forEach(function (item) {
      if (item.__ahhFaq) return; item.__ahhFaq = 1;
      var btn = item.querySelector('.ahh-faq-q');
      var ans = item.querySelector('.ahh-faq-a');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === '1';
        var list = item.closest('.ahh-faq-list');
        if (list) {
          list.querySelectorAll('.ahh-faq-item').forEach(function (o) {
            if (o !== item) {
              o.setAttribute('data-open', '0');
              var a = o.querySelector('.ahh-faq-a');
              if (a) { a.style.maxHeight = '0px'; a.style.opacity = '0'; a.style.paddingBottom = '0px'; }
            }
          });
        }
        item.setAttribute('data-open', open ? '0' : '1');
        ans.style.maxHeight = open ? '0px' : (ans.scrollHeight + 40) + 'px';
        ans.style.opacity = open ? '0' : '1';
        ans.style.paddingBottom = open ? '0px' : '22px';
      });
    });
  }

  function bindMagnetic(root) {
    if (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.ahh [data-magnetic]').forEach(function (btn) {
      if (btn.__ahhMag) return; btn.__ahhMag = 1;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - r.left - r.width / 2;
        var my = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (mx * 0.22) + 'px,' + (my * 0.32) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = 'translate(0,0)'; });
    });
  }

  // Scroll source differs by viewport in Horizon: at >=990px the page scrolls
  // INSIDE .page-wrapper (html/body are overflow:hidden); below 990px the window
  // scrolls normally and .page-wrapper.scrollTop stays 0. So don't pick one —
  // read whichever is actually scrolling (the inactive one stays 0) and subscribe
  // to both, so the nav tracks scroll on desktop AND mobile, and across resizes.
  function ahhScrollY() {
    var w = document.querySelector('.page-wrapper');
    return Math.max(
      window.pageYOffset || 0,
      (document.documentElement && document.documentElement.scrollTop) || 0,
      (w && w.scrollTop) || 0
    );
  }
  function ahhOnScroll(fn) {
    window.addEventListener('scroll', fn, { passive: true });
    var w = document.querySelector('.page-wrapper');
    if (w) w.addEventListener('scroll', fn, { passive: true });
  }

  function bindNav() {
    var nav = document.querySelector('.ahh-nav');
    if (nav && !nav.__ahhScroll) {
      nav.__ahhScroll = 1;
      var onScroll = function () { nav.classList.toggle('is-scrolled', ahhScrollY() > 40); };
      ahhOnScroll(onScroll);
      onScroll();
    }
    var panel = document.querySelector('.ahh-drawer');
    var back = document.querySelector('.ahh-drawer-back');
    if (panel && back && !panel.__ahhDrawer) {
      panel.__ahhDrawer = 1;
      var openBtn = document.querySelector('[data-ahh-menu-open]');
      var closeBtn = document.querySelector('[data-ahh-menu-close]');
      var open = function () { panel.classList.add('is-open'); back.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
      var close = function () { panel.classList.remove('is-open'); back.classList.remove('is-open'); document.body.style.overflow = ''; };
      if (openBtn) openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      back.addEventListener('click', close);
      document.querySelectorAll('.ahh-drawer-link, .ahh-drawer-mini a').forEach(function (a) { a.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  function bindTopbar() {
    // Announcement bar scrolls away in normal flow; only the nav is fixed.
    // Keep the nav tucked below the announcement until it scrolls off, then pin to top.
    var ann = document.querySelector('.ahh-announce');
    var nav = document.querySelector('.ahh-nav');
    var sp = document.querySelector('.ahh-nav-spacer');
    if (!nav || !sp) return;
    var annH = function () { return (ann && ann.offsetParent !== null) ? ann.offsetHeight : 0; };
    var place = function () {
      sp.style.height = nav.offsetHeight + 'px';
      var y = ahhScrollY();
      nav.style.top = Math.max(0, annH() - y) + 'px';
    };
    place();
    if (!nav.__ahhFixed) {
      nav.__ahhFixed = 1;
      ahhOnScroll(place);
      window.addEventListener('resize', place);
      window.addEventListener('load', place);
      if (window.ResizeObserver) {
        try {
          new ResizeObserver(place).observe(nav);
          if (ann) new ResizeObserver(place).observe(ann);
        } catch (e) {}
      }
    }
  }

  function bindAll(root) {
    reveal(root);
    bindFaq(root);
    bindMagnetic(root);
    bindNav();
    bindTopbar();
  }

  if (document.readyState !== 'loading') bindAll(document);
  else document.addEventListener('DOMContentLoaded', function () { bindAll(document); });

  // Theme editor: re-reveal + re-bind whenever a section is (re)loaded or selected.
  document.addEventListener('shopify:section:load', function (e) { bindAll(e.target || document); });
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target || document); });
  document.addEventListener('shopify:section:unload', function () {});
})();
